import { useQueryClient } from '@tanstack/react-query';

import { callGetCollectionMetadataByToken } from '@app/client/resources/marketplace';
export const COLLECTION_METADATA_BY_TOKEN_CACHE = 'fantasy-collections-by-token';

export function useFetchMetadataByToken() {
    const queryClient = useQueryClient();
    // TODO rename
    return async (tokenItem, ignoreSignal?: boolean) => {
        const contract = tokenItem.contract_address;
        const tokenId = tokenItem.token_id.toString();

        const cache = [COLLECTION_METADATA_BY_TOKEN_CACHE, contract, tokenId];
        return await queryClient.ensureQueryData({
            queryKey: cache,
            queryFn: ({ signal }) =>
                callGetCollectionMetadataByToken({
                    contract,
                    tokenId,
                    settings: { signal: ignoreSignal ? undefined : signal },
                }),
        });
    };
}
